import {
    CHANGE_FORM_DATA, CHANGE_MANAGE_SOL_ACCOUNT_SETTINGS, LOGOUT, RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR,
    RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR_PASSWORD, RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS,
    RECEIVE_GET_ACCEPTED_TOBA,
    RECEIVE_GET_SOLICITOR_DETAILS, RECEIVE_UPDATE_SOLICITOR_PASSWORD_RESPONSE,
    RECEIVE_UPDATE_SOLICITOR_RESPONSE, REQUEST_GET_SOLICITOR_DETAILS, REQUEST_UPDATE_SOLICITOR_DETAILS,
    REQUEST_UPDATE_SOLICITOR_PASSWORD, TOGGLE_ERROR,
    REQUEST_GET_LAWSYS_DETAILS, RECEIVE_GET_LAWSYS_DETAILS, RECEIVE_FAILED_RESPONSE_GET_LAWSYS_DETAILS
} from "../actions/index";
import {REQUEST_GET_ACCEPTED_TOBA, REQUEST_GET_ACCEPTED_TOBA_FAIL} from "../actions";

const defaultState = {
    formData: {
        forename: "",
        surname: "",
        telephoneNumber1: "",
        telephoneNumber1Description: "",
        telephoneNumber2: "",
        telephoneNumber2Description: "",
        password: "",
        newPassword:"",
        retypedNewPassword:""
    },
    solicitorData: {
        id: null,
        userName: "",
        forename: "",
        surname: "",
        email: "",
        lastAcceptedTobaId: null,
        lastAcceptedTobaDate: "",
        lawsysId: "",
        lawsysName: "",
        telephone1: "",
        telephone1Description: "",
        telephone2: "",
        telephone2Description: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        postCode: "",
        country: ""
    },
    lawsysData:{
        id: "",
        name: "",
        address: "",
        postcode: "",
    },
    error: {
        shortPassword: false,
        notComplexPassword: false,
        notSamePassword: false,
        wrongOldPassword:false,
        errorMessage: ''
    },
    errorExists: false,
    posting: false,
    postResponse: '',
    badResponse: '',
    acceptedToba: {},
    notValidTel1: '',
    notValidTel2: '',
    openModal:false,
    patchingPassword: false,
    badResponsePassword: '',
    fetchingSolicitorUserDetails: false,
    failedToGetSolicitorUserDetailsMsg: '',
    fetchingAcceptedToba: false,
    fetchingAcceptedTobaFailMessage: '',
    fetchingLawsysDetails: false,
    failedToGetLawsysDetailsMsg: '',
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case REQUEST_GET_ACCEPTED_TOBA:
            return {
                ...state,
                fetchingAcceptedToba: true
            };
        case RECEIVE_GET_ACCEPTED_TOBA:
            return {
                ...state,
                fetchingAcceptedToba: false,
                acceptedToba: action.payload
            };
        case REQUEST_GET_ACCEPTED_TOBA_FAIL:
            let fetchingAcceptedTobaFailMessage = '';
            try {
                fetchingAcceptedTobaFailMessage = action.payload.response.body.message
            } catch (e) {
                fetchingAcceptedTobaFailMessage = 'Failed to fetch TOBA.'
            }
            return {
                ...state,
                fetchingAcceptedToba: false,
                fetchingAcceptedTobaFailMessage: fetchingAcceptedTobaFailMessage
            };
        case CHANGE_FORM_DATA:
            return {
                ...state,
                formData: {...state.formData, [action.payload.key]: action.payload.value},
                error: defaultState.error,
                errorExists: false,
                postResponse: '',
                badResponse: '',
                badResponsePassword: '',
                notValidTel1: '',
                notValidTel2: ''
            };
        case REQUEST_GET_LAWSYS_DETAILS:
            return {
                ...state,
                fetchingLawsysDetails: true,
                failedToGetLawsysDetailsMsg: ''
            };
        case RECEIVE_GET_LAWSYS_DETAILS:
            return {
                ...state,
                lawsysData: {
                    ...state.lawsysData,
                    id: action.payload.id?action.payload.id:'',
                    name: action.payload.name?action.payload.name:'',
                    address: action.payload.address?action.payload.address:'',
                    postcode: action.payload.postcode?action.payload.postcode:'',
                },
                fetchingLawsysDetails: false,
                failedToGetLawsysDetailsMsg: ''
            };
        case RECEIVE_FAILED_RESPONSE_GET_LAWSYS_DETAILS:
            return {
                ...state,
                fetchingLawsysDetails: false,
                failedToGetLawsysDetailsMsg: 'Failed to get lawsys information. Please try again later.'
            };
        case REQUEST_GET_SOLICITOR_DETAILS:
            return {
                ...state,
                fetchingSolicitorUserDetails: true,
                failedToGetSolicitorUserDetailsMsg: ''
            };
        case RECEIVE_GET_SOLICITOR_DETAILS:
            return {
                ...state,
                solicitorData: {...state.solicitorData, ...action.payload},
                formData: {
                    ...state.formData,
                    telephoneNumber1: action.payload.telephone1?action.payload.telephone1:'',
                    telephoneNumber1Description: action.payload.telephone1Description?action.payload.telephone1Description:'',
                    telephoneNumber2: action.payload.telephone2?action.payload.telephone2:'',
                    telephoneNumber2Description: action.payload.telephone2Description?action.payload.telephone2Description:'',
                    forename: action.payload.forename?action.payload.forename:'',
                    surname: action.payload.surname?action.payload.surname:''
                },
                fetchingSolicitorUserDetails: false,
                failedToGetSolicitorUserDetailsMsg: ''
            };
        case RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS:
            return {
                ...state,
                fetchingSolicitorUserDetails: false,
                failedToGetSolicitorUserDetailsMsg: 'Failed to get the account information. Please try again later.'
            };
        case RECEIVE_UPDATE_SOLICITOR_RESPONSE:
            return {
                ...state,
                formData: {
                    ...defaultState.formData,
                    telephoneNumber1: action.payload.telephone1?action.payload.telephone1:'',
                    telephoneNumber1Description: action.payload.telephone1Description?action.payload.telephone1Description:'',
                    telephoneNumber2: action.payload.telephone2?action.payload.telephone2:'',
                    telephoneNumber2Description: action.payload.telephone2Description?action.payload.telephone2Description:'',
                    forename: action.payload.forename?action.payload.forename:'',
                    surname: action.payload.surname?action.payload.surname:''
                },
                solicitorData: action.payload,
                error: defaultState.error,
                errorExists: false,
                posting: false,
                postResponse: 'Updated successfully.',
                notValidTel1: '',
                notValidTel2: ''
            };
        case RECEIVE_UPDATE_SOLICITOR_PASSWORD_RESPONSE:
            return {
                ...state,
                formData: {
                    ...defaultState.formData,
                    telephoneNumber1: action.payload.telephone1?action.payload.telephone1:'',
                    telephoneNumber1Description: action.payload.telephone1Description?action.payload.telephone1Description:'',
                    telephoneNumber2: action.payload.telephone2?action.payload.telephone2:'',
                    telephoneNumber2Description: action.payload.telephone2Description?action.payload.telephone2Description:'',
                    forename: action.payload.forename?action.payload.forename:'',
                    surname: action.payload.surname?action.payload.surname:''
                },
                solicitorData: action.payload,
                error: defaultState.error,
                errorExists: false,
                posting: false,
                postResponse: 'Updated successfully.',
                notValidTel1: '',
                notValidTel2: '',
                openModal:false,
                patchingPassword: false,
                badResponsePassword: ''
            };
        case RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR:
            return {
                ...state,
                badResponse: 'Failed to update the user account.',
                posting: false,
            };
        case RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR_PASSWORD:
            return {
                ...state,
                badResponsePassword: action.payload,
                patchingPassword: false,
            };
        case REQUEST_UPDATE_SOLICITOR_DETAILS:
            return {
                ...state,
                posting: true
            };
        case REQUEST_UPDATE_SOLICITOR_PASSWORD:
            return {
                ...state,
                patchingPassword: true
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        case TOGGLE_ERROR:
            return {
                ...state,
                error: {...defaultState.error, [action.payload.key]: true , errorMessage: action.payload.value},
                errorExists: true
        };
        case CHANGE_MANAGE_SOL_ACCOUNT_SETTINGS:
            if(action.payload.key === 'openModal' && (action.payload.value === false))
                return {
                    ...state,
                    formData: {...state.formData, newPassword:'', password: '', retypedNewPassword: ''},
                    [action.payload.key] : action.payload.value,
                    error: defaultState.error,
                    badResponsePassword: defaultState.badResponsePassword
                };
            return {
                ...state,
                [action.payload.key] : action.payload.value
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                acceptedToba: defaultState.acceptedToba,
                fetchingAcceptedTobaFailMessage: defaultState.fetchingAcceptedTobaFailMessage
            };
        default:
            return state
    }
}